import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { Settings } from "lucide-react";
import { Button } from "@/shared/components/ui/button";
import { useIsSuperAdminRole } from "@/shared/hooks/use-system-role";
import { useWorkspace } from "@/features/Workspaces/state/WorkspaceContext";
import PlaygroundConfigDialog from "./PlaygroundConfigDialog";

const SETTINGS_PARAM = "settings";
const SETTINGS_OPEN = "chat";

/**
 * Configurações do Chat (AB#87121): a engrenagem ao lado do título no breadcrumb da
 * navbar, no lugar das que ficavam no cabeçalho do chat. Só superadmin, como antes.
 * A abertura vive no `?settings=chat`, para o link continuar valendo.
 */
export function ChatSettingsButton() {
  const { t } = useTranslation();
  const { isSuperAdmin } = useIsSuperAdminRole();
  const { currentWorkspace } = useWorkspace();
  const [searchParams, setSearchParams] = useSearchParams();
  const open = searchParams.get(SETTINGS_PARAM) === SETTINGS_OPEN;

  if (!isSuperAdmin) return null;

  const setOpen = (next: boolean) => {
    setSearchParams(
      (params) => {
        if (next) params.set(SETTINGS_PARAM, SETTINGS_OPEN);
        else params.delete(SETTINGS_PARAM);
        return params;
      },
      { replace: true },
    );
  };

  return (
    <>
      <Button
        variant="ghost"
        size="icon"
        className="h-8 w-8 text-muted-foreground hover:text-foreground"
        onClick={() => setOpen(true)}
        aria-label={t("playground.view.settings")}
        title={t("playground.view.settings")}
      >
        <Settings className="h-4 w-4" />
      </Button>
      <PlaygroundConfigDialog
        isOpen={open}
        onClose={() => setOpen(false)}
        workspaceId={currentWorkspace?.id || ""}
      />
    </>
  );
}
